export const leftMargin = 50;